import { ButtonPropsModal } from '@celebration/react/ClbModal/ClbModal.types';

const backButton = (
    t: (key: string) => string,
    titleKey: string,
    setIsExitModalOpen: (value: React.SetStateAction<boolean>) => void,
): ButtonPropsModal => ({
    key: 'back-button',
    id: 'back-button',
    label: t('Voltar'),
    disabled: false,
    loading: false,
    title: t(titleKey),
    'data-testid': 'modal-back-button',
    onClick: () => setIsExitModalOpen(false),
    role: 'button',
    size: 'md',
    styleType: 'secondary',
});

const exitButton = (
    t: (key: string) => string,
    titleKey: string,
    closeModalHandler: () => void,
): ButtonPropsModal => ({
    key: 'exit-button',
    id: 'exit-button',
    label: t('Sair'),
    disabled: false,
    loading: false,
    title: t(titleKey),
    'data-testid': 'modal-exit-button',
    onClick: () => closeModalHandler(),
    role: 'button',
    size: 'md',
    styleType: 'danger',
});

const buttonsModal = {
    exitButton,
    backButton,
};

export default buttonsModal;
